'use client';
import Hero from '@/app/booking/hero';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page() {
  return (
    <div>
      <>
        <title>Booking Information | Prestige Ride</title>
        <meta
          name="description"
          content=" Provide the pickup and drop-off location with the date and time to
          proceed. You can add multiple stops if needed to customize your travel
          experience.
        
        "
        />
        <meta name="robots" content="index, follow" />
        <meta name="keywords" content="" />
        <link rel="canonical" href="https://www.prestigeride.com/booking" />
      </>
      <Navbar />
      <Hero />
      <Footer />
    </div>
  );
}

export default page;
